import { ReactNode } from "react";

export const RETRY_KEY = "lazy_load_retry_count";

export class ImportError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ImportError";
  }
}

// Error component for failed imports
export function ImportErrorComponent({ fallback }: { fallback?: ReactNode }) {
  return (
    fallback || (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2>Failed to Load Page</h2>
        <p>Sorry, this page failed to load after multiple attempts.</p>
        <button
          onClick={() => {
            sessionStorage.removeItem(RETRY_KEY);
            window.location.reload();
          }}
          style={{
            padding: "10px 20px",
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Try Again
        </button>
      </div>
    )
  );
}
